import { environment } from './environments/environment';

/**
 * @deprecated at auth module config (const.ts)
 */
export const API_VERSIONs = {
  VERSION_1_0_0: '1.0.0',
  VERSION_2_0_0: '2.0.0',
};

export const API_ENDPOINTS = {
  cap_phat_dong_phuc: `${environment.domain.apiTuyenSinhCapDongPhuc}/cap-dong-phuc`,
  cap_phat_dong_phuc_setting: `${environment.domain.apiTuyenSinhCapDongPhuc}/setting`,
  phieuThu: `${environment.domain.apiTuyenSinhCapDongPhuc}/cap-dong-phuc/phieu-thu`,
  xuLyTrongNgay: `${environment.domain.apiTuyenSinhCapDongPhuc}/cap-dong-phuc/phieu-thu/xu-ly-trong-ngay`,
  cap_phat_dong_phuc_thong_ke_ggsheet: `${environment.domain.apiTuyenSinhCapDongPhuc}/thong-ke-ggsheet`,
  thongKeBaoCao: `${environment.domain.apiTuyenSinhCapDongPhuc}/cap-dong-phuc/phieu-thu/bao-cao-thong-ke`,
  log: `${environment.domain.apiTuyenSinhCapDongPhuc}/log`,
  dataBanDau: `${environment.domain.apiTuyenSinhCapDongPhuc}/data-ban-dau`,  
};
